import { Autocomplete, Button, InputAdornment, TextField } from "@mui/material";
import { Box, Grid } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import ReportsFilterItems from "./ReportsFilterItems";
import { FilterOption } from "../Configs/ConfigsFilterItems";

interface Props {
  /** distinct report names, deduped by the owning tab */
  searchOptions: string[];
  selectedName: string | null;
  onSelectName: (value: string | null) => void;
  interfaceOptions: FilterOption[];
  selectedInterfaces: string[];
  onSelectedInterfacesChange: (value: string[]) => void;
  onClearFilters: () => void;
  canCreate: boolean;
  onCreate: () => void;
}

/** Search box, filter buttons and the create action above the Reports table. */
const ReportsFilterCard = ({
  searchOptions,
  selectedName,
  onSelectName,
  canCreate,
  onCreate,
  ...filterItemProps
}: Props) => (
  <Box sx={{ padding: "16px 16px 8px" }}>
    <Grid container rowSpacing={2} columnSpacing={3} alignItems="center">
      <Grid size={3}>
        <Autocomplete
          data-tracker="1111"
          sx={{ width: "100%" }}
          options={searchOptions}
          value={selectedName}
          onChange={(_, newValue) => onSelectName(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Report Name"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "12px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
        />
      </Grid>
      <Grid size={6}>
        <ReportsFilterItems {...filterItemProps} />
      </Grid>
      <Grid size={3}>
        <Box display="flex" justifyContent="flex-end">
          {canCreate && (
            <Button
              variant="contained"
              color="secondary"
              sx={{ whiteSpace: "nowrap" }}
              onClick={onCreate}
              disabled
            >
              Create new Report <AddIcon sx={{ width: "20px", ml: "5px" }} />
            </Button>
          )}
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default ReportsFilterCard;
